module.exports = __webpack_public_path__ + "static/media/door00.53a22f36.png";